export default __webpack_public_path__ + "static/media/monkey.49dbb724.png";